import { COUNTRIES_PHONE_FORMAT, CountryWithPhoneFormat } from 'config';

export const formatPhonePol = (inputNumbers: string) => {
  const { countryCode } =
    COUNTRIES_PHONE_FORMAT[CountryWithPhoneFormat.Poland]!;

  let formattedInputValue = `${countryCode} `;

  if (inputNumbers.length === 1) {
    formattedInputValue = `${formattedInputValue}${inputNumbers.substring(
      0,
      1,
    )}`;
  }
  if (inputNumbers.length >= 3) {
    formattedInputValue = `${formattedInputValue}${inputNumbers.substring(
      2,
      5,
    )}`;
  }
  if (inputNumbers.length >= 6) {
    formattedInputValue = `${formattedInputValue}-${inputNumbers.substring(
      5,
      8,
    )}`;
  }
  if (inputNumbers.length >= 9) {
    formattedInputValue = `${formattedInputValue}-${inputNumbers.substring(
      8,
      11,
    )}`;
  }

  return formattedInputValue;
};
